import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	posts: [],
	errorMessage: null,
	currentPost: {},
};

export default function postsReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_POSTS_SUCCESS:
			return Object.assign({}, state, {
				posts: action.posts,
			});
		case ActionTypes.LOAD_POSTS_FAIL:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		case ActionTypes.SELECT_POST_SUCCESS:
			return Object.assign({}, state, {
				currentPost: action.post,
			});
		case ActionTypes.RESET_CURRENT_POST:
			return Object.assign({}, state, {
				currentPost: {},
			});
		default:
			return state;
	}
}
